export default (state, action) => ({
  ...state,
  promoCodes: {
    ...state.promoCodes,
    isAdding: true,
    isRemoving: false,
    requestedPromoCode: action?.code,
    serverError: null,
  },
  waiting: true,
});
